import { render, staticRenderFns } from "./CompContactsModalContact.vue?vue&type=template&id=3f422627"
import script from "./CompContactsModalContact.vue?vue&type=script&setup=true&lang=js"
export * from "./CompContactsModalContact.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompContactsModalContact.vue?vue&type=style&index=0&id=3f422627&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports